/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  COPPA_DESCRIPTIONS,
  COPPA_TARGET_CHILDREN_ICONS,
  COPPA_TARGET_CHILDREN_LABELS
} from 'app/constants/COPPA_PERMISSIONS';
import { User } from 'app/models/User';
import {
  MediaQueryService,
  Breakpoint
} from 'app/services/media-query.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-coppa-permissions',
  templateUrl: './app-coppa-permissions.html',
  styleUrls: ['./app-coppa-permissions.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppCoppaPermissions implements OnInit {
  Breakpoint = Breakpoint;

  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();

  showDangerous = true;
  descriptions = COPPA_DESCRIPTIONS;

  bp$: Observable<Breakpoint>;

  private permissions: BehaviorSubject<any[]> = new BehaviorSubject([]);

  permissions$: Observable<any[]>;

  get targetChildrenActiveLabel() {
    return COPPA_TARGET_CHILDREN_LABELS[
      this.data?.coppaPermissions?.targetChildrenRisk || 'na'
    ];
  }

  get targetChildrenActiveIcon() {
    return COPPA_TARGET_CHILDREN_ICONS[
      this.data?.coppaPermissions?.targetChildrenRisk || 'na'
    ];
  }

  get targetChildrenReason() {
    const reasons = this.data?.coppaPermissions?.targetChildrenRiskReason;
    if (reasons && reasons[0]) return reasons[0];
    return this.targetChildrenActiveLabel;
  }

  get teacherApprovedString() {
    const approved = this.data?.coppaPermissions?.isApprovedByTeacher;
    const approvedStr = this.data?.coppaPermissions?.ageGroupApprovedByTeachers;
    if (approved === true || approved === 'true') {
      if (approvedStr && approvedStr !== 'N/A') {
        return approvedStr;
      } else {
        return 'Yes';
      }
    } else {
      return 'No';
    }
  }

  constructor(_media: MediaQueryService, public user: User) {
    this.bp$ = _media.activeBreakpoint$;

    this.permissions$ = this.permissions.pipe(
      map(perms => {
        return perms.map(p => ({
          dangerous:
            p.isDangerous && p.effects && p.effects.includes('Privacy'),
          name: p.name,
          description: p.description
        }));
      })
    );
  }

  ngOnInit() {
    this.showDangerousClick(true);
  }

  showDangerousClick(showDangerous: boolean) {
    this.showDangerous = showDangerous;

    let perms = [];

    if (this.showDangerous && this.data['coppaPermissions']['permissions']) {
      perms = this.data['coppaPermissions']['permissions'].filter(
        permission => {
          const effects = permission.effects || [];
          return permission.isDangerous && effects.indexOf('Privacy') >= 0;
        }
      );
    } else {
      perms = this.data['coppaPermissions']['permissions'];
    }

    this.permissions.next(perms);
  }

  trackPermissions(index: number, perm: any) {
    return perm.name;
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
